import { Div, Grid } from '@fastnorth/kraken/components/layout';
import { CardSkeleton } from '@fastnorth/kraken/components/card';
import { H2 } from '@fastnorth/kraken/components/typography';
import { useResponsive } from '@fastnorth/kraken/components/page-layout';
import { useTranslation } from 'react-i18next';

const HomeSkeleton = (): React.JSX.Element => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event.race_list' });

  return (
    <>
      <H2 fontWeight={'bold'} color={'muted'} size={'2xl'} spacing={'0 0 6'}>
        {t('title')}
      </H2>
      <Grid
        data-testid="skeleton-grid"
        className={`${isMobile ? 'grid-flow-col overflow-x-scroll pb-6' : ''} lg:grid-cols-3 lg:grid-flow-row`}
        gap={'7'}>
        {Array.from(new Array(3), (_, idx) => idx).map((id) => (
          <Div
            className={'min-w-[280px]'}
            data-testid={`skeleton-drop-card`}
            key={`drop-card-skeleton-${id}`}>
            <CardSkeleton height={'full'} header={true} footer={true} />
          </Div>
        ))}
      </Grid>
    </>
  );
};

export default HomeSkeleton;
